import { useQuery } from "@tanstack/react-query";
import Link from "next/link";
import { strapiClient } from "~/strapi/api";

type AccountStatus = "not_created" | "pending" | "verified" | "restricted_soon";

type StatusResponse = {
  data: { status: AccountStatus; storeId?: number };
};

const useStripeAccountStatus = () =>
  useQuery({
    queryKey: ["stripeAccountStatus"],
    queryFn: async () => {
      const res = await strapiClient.get<StatusResponse>(
        "/stores/stripe-account-status"
      );
      return res.data.data;
    },
    retry: false,
  });

export const StripeVerificationBanner = () => {
  const { data, isLoading } = useStripeAccountStatus();

  if (isLoading || !data || data.status === "verified") return null;

  const handleGoToStripe = async () => {
    if (!data.storeId) return;
    const returnUrl =
      window.location.origin +
      window.location.pathname +
      "?step=stripeVerification";
    const params = new URLSearchParams({
      returnUrl,
      refreshUrl: returnUrl,
    });
    try {
      const res = await strapiClient.get<{ data: { url: string } }>(
        `/stores/${data.storeId}/stripe-onboarding-link?${params.toString()}`
      );
      window.location.href = res.data.data.url;
    } catch {
      // silently ignore — user can retry
    }
  };

  return (
    <div className="bg-warning-100 border-b border-warning-300 px-4 py-3 flex items-center gap-4 text-sm">
      <span className="font-medium text-warning-800">
        {data.status === "not_created"
          ? "Din Stripe-konto er ikke oprettet endnu."
          : data.status === "restricted_soon"
          ? "Din Stripe-konto vil snart blive begrænset – dine oplysninger skal opdateres."
          : "Din Stripe-konto afventer verificering."}
      </span>
      {data.status === "not_created" ? (
        <Link
          href={{ pathname: "/backroom/store/edit", query: { step: "companyDetails" } }}
          className="underline text-warning-900 font-semibold"
        >
          Opret konto
        </Link>
      ) : (
        <button
          onClick={handleGoToStripe}
          className="underline text-warning-900 font-semibold"
        >
          {data.status === "restricted_soon" ? "Opdater oplysninger hos Stripe" : "Fuldfør verificering hos Stripe"}
        </button>
      )}
    </div>
  );
};
